import React from 'react';
import { Alert } from '@mui/material';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';
import { getWarningMessage } from '../constants';

interface WarningSectionProps {
  approval: WriteoffApprovalView;
}

export const WarningSection: React.FC<WarningSectionProps> = ({ approval }) => (
  <Alert severity="warning">{getWarningMessage(approval)}</Alert>
);

export default WarningSection;
